import { CREATE_POA_USER } from './mutations/poaUsers/create.poa.user';
import {
  CorePOAUsersCreateRepresentativeInput,
  CorePOAUsersCreateRepresentativeResponse,
  CorePOAUsersUpdateRepresentativeInput,
} from './mutations/poaUsers/types';
import { UPDATE_POA_USER } from './mutations/poaUsers/update.poa.user';
import { api, ApiTags } from './base';
import {
  CheckCertificatesQuery,
  GetIdPoaUserQuery,
  SearchPoaUsersQuery,
  useGetIdPoaUserQuery,
  useLazyCheckCertificatesQuery as useGeneratedLazyCheckCertificatesQuery,
  useSearchPoaUsersQuery,
} from './generated';
import { unwrapLazyQuery, unwrapQuery } from './unwrap';

export const useSearchPoausersQuery = (...args: Parameters<typeof useSearchPoaUsersQuery>) =>
  unwrapQuery(
    useSearchPoaUsersQuery(...args),
    (raw: SearchPoaUsersQuery | undefined) => raw?.corePOAUsers?.search ?? [],
  );

export const useGetByIdPoaUserQuery = (...args: Parameters<typeof useGetIdPoaUserQuery>) =>
  unwrapQuery(
    useGetIdPoaUserQuery(...args),
    (raw: GetIdPoaUserQuery | undefined) => raw?.corePOAUsers?.getData,
  );

export const useLazyCheckCertificatesQuery = (
  ...args: Parameters<typeof useGeneratedLazyCheckCertificatesQuery>
) =>
  unwrapLazyQuery(
    useGeneratedLazyCheckCertificatesQuery(...args),
    (raw: CheckCertificatesQuery | undefined) => raw?.corePOAUsers?.checkCertificates,
  );

/** Мутации оставлены рукописными: результат создания представителя читают из промиса триггера. */
export const poaUsersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createPoaRepresentative: builder.mutation<
      CorePOAUsersCreateRepresentativeResponse,
      CorePOAUsersCreateRepresentativeInput
    >({
      query: ({ request, userType }) => ({
        document: CREATE_POA_USER,
        variables: { request, userType },
      }),
      invalidatesTags: [ApiTags.PoaUserList],
    }),
    updatePoaRepresentative: builder.mutation<void, CorePOAUsersUpdateRepresentativeInput>({
      query: ({ data, userId, userType }) => ({
        document: UPDATE_POA_USER,
        variables: { data, userId, userType },
      }),
    }),
  }),
});

export const { useCreatePoaRepresentativeMutation, useUpdatePoaRepresentativeMutation } =
  poaUsersApi;
